import React from "react";
import { RouteObject } from "../../interfaces/navigation";

const Dealerships = React.lazy(() => import("../../containers/Dealerships/EntrypointContainer"));

export const dealershipsRoutes: RouteObject[] = [
    {
        path: "/dealerships",
        component: <Dealerships />,
        title: "Concesionarios"
    },
    {
        path: "/dealerships/:dealershipCode",
        component: <Dealerships />,
        title: "Concesionarios"
    },
    
];
